import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class ErrorPageService {
	private errorPageSubject = new Subject<ErrorPage>();
	public errorPageObservable = this.errorPageSubject.asObservable();


	constructor() {
	}

	pushErrorPage(errorPage: ErrorPage) {
		//this.errorPageSubject.next(errorPage);
	}
}

export class ErrorPage {
	//txt1
	static PAGE_NOT_FOUND = 'PAGE_NOT_FOUND';
	//txt2
	static OPS = 'OPS';
	//txt3
	static NOT_COMMODITIES = 'NOT_COMMODITIES';
	static URL_ERROR = 'URL_ERROR';
	//buttonTxt
	static LOGOUT = 'LOGOUT';
	static GO_TO = 'GO_TO';

	image: string;
	route: any;
	txt1: string;
	txt2: string;
	txt3: string;
	buttonTxt: string;

	static get404ErrorPage(): ErrorPage {
		const errorPage = new ErrorPage();
		errorPage.image = 'ico-404.png';
		errorPage.txt1 = ErrorPage.PAGE_NOT_FOUND;
		errorPage.txt2 = ErrorPage.OPS;
		errorPage.txt3 = ErrorPage.PAGE_NOT_FOUND;
		errorPage.buttonTxt = ErrorPage.LOGOUT;
		return errorPage;
	}

	static get404ErrorPageNotLogout(): ErrorPage {
		const errorPage = new ErrorPage();
		errorPage.image = 'ico-404.png';
		errorPage.txt1 = ErrorPage.PAGE_NOT_FOUND;
		errorPage.txt2 = ErrorPage.OPS;
		errorPage.txt3 = ErrorPage.PAGE_NOT_FOUND;
		errorPage.buttonTxt = null;
		return errorPage;
	}

	static getNoCommoditiesErrorPage(): ErrorPage {
		const errorPage = new ErrorPage();
		errorPage.image = 'ico-404.png';
		errorPage.txt1 = ErrorPage.PAGE_NOT_FOUND;
		errorPage.txt2 = ErrorPage.OPS;
		errorPage.txt3 = ErrorPage.NOT_COMMODITIES;
		errorPage.buttonTxt = ErrorPage.LOGOUT;
		return errorPage;
	}
}
